export const sizes = {
  // veryoldmobile: 376,
  mobile: 576,
  ipad: 768,
  medium: 992,
  large: 1200,
  larger: 1400, // don't think we need this? (not recommended?)
};
